module.exports = __webpack_public_path__ + "img/qudao2.4ce7d294.png";